export default __webpack_public_path__ + "1893614c97f55a132d9cc2cfafe3b027.png";